import {TrackTraceLanguage, TrackTraceMessageKey, TrackTraceReason, trackTraceLanguages} from '../../types/trackTrace.js'

const nl = {
    languageName: 'Nederlands',
    changeLanguage: 'Taal wijzigen',
    loading: 'Je zending wordt geladen…',
    notFoundTitle: 'Zending niet gevonden',
    notFoundText: 'We kunnen geen zending vinden met deze Track & Trace-code. Controleer de code en probeer het opnieuw.',
    errorTitle: 'Er ging iets mis',
    errorText: 'We konden je zending nu niet ophalen. Probeer het over een paar minuten opnieuw.',
    retry: 'Opnieuw proberen',
    trackTraceCode: 'Track & Trace-code',
    search: 'Zoeken',

    stepsDelivery: ['Aangemeld', 'Ingepland', 'Onderweg', 'Bezorgd'],
    stepsPickup: ['Aangemeld', 'Ingepland', 'Onderweg', 'Opgehaald'],
    stepOf: 'Stap {step} van {total}',

    eyebrowExpected: 'Je zending is aangemeld',
    eyebrowScheduledDelivery: 'Verwachte bezorging',
    eyebrowScheduledPickup: 'Verwachte ophaling',
    eyebrowOnTheWayDelivery: 'Onderweg naar jou',
    eyebrowOnTheWayPickup: 'Onderweg om op te halen',
    eyebrowCompletedDelivery: 'Bezorgd',
    eyebrowCompletedPickup: 'Opgehaald',
    eyebrowNotCompletedDelivery: 'Bezorging niet gelukt',
    eyebrowNotCompletedPickup: 'Ophalen niet gelukt',
    eyebrowReturning: 'Retour afzender',
    eyebrowOnHold: 'In bewaring',
    eyebrowCancelled: 'Geannuleerd',

    titleDateUnknown: 'Datum volgt',
    titleCompletedAt: '{date} om {time}',
    titleNotCompleted: 'We hebben je gemist',
    titleAttemptFailed: 'Poging niet gelukt',
    titleReturning: 'Terug naar de afzender',
    titleOnHoldUntil: 'Tot {date}',
    titleCancelled: 'Zending geannuleerd',

    subExpected: 'We laten je weten wanneer je zending wordt ingepland.',
    subWindow: 'Tussen {from} en {to}',
    subOnTheWay: 'Je zending is vandaag onderweg.',
    subCompletedDelivery: 'Je zending is afgeleverd.',
    subCompletedPickup: 'Je zending is opgehaald.',
    subNeighbour: 'Afgegeven bij de buren op huisnummer {nr}.',
    subNeighbourUnknown: 'Afgegeven bij de buren.',
    subMailbox: 'Bezorgd in de brievenbus.',

    today: 'vandaag',
    tomorrow: 'morgen',
    yesterday: 'gisteren',

    windowLabel: 'Tijdvak',
    dateLabel: 'Datum',
    deliveryAddress: 'Bezorgadres',
    pickupAddress: 'Ophaaladres',
    shipment: 'Zending',
    shipmentFrom: '{count} van {sender}',
    parcels: ['{count} pakket', '{count} pakketten'],

    requirementsTitle: 'Goed om te weten',
    reqSignature: 'Voor ontvangst is een handtekening nodig.',
    reqStatedAddressOnly: 'We bezorgen alleen op dit adres, niet bij de buren.',
    reqMailbox: 'Je zending past door de brievenbus.',
    reqMinimumAge: 'De ontvanger moet minimaal {age} jaar oud zijn.',
    reqIdCheck: 'Houd een geldig legitimatiebewijs bij de hand.',
    reqVerificationCode: 'Voor ontvangst heb je een bezorgcode nodig.',

    incompleteLink: 'Deze link is niet volledig. Gebruik de link uit je e-mail.',
    searchTitle: 'Volg je zending',
    searchText: 'Vul de Track & Trace-code en de postcode van het adres in.',
    postalCode: 'Postcode',
    confirm: 'Bevestigen',
    tooManyAttempts: 'Te veel pogingen. Probeer het over een kwartier opnieuw.',

    proofTitleDelivery: 'Bewijs van aflevering',
    proofTitlePickup: 'Bewijs van ophalen',
    signee: 'Ontvangen door',
    signature: 'Handtekening',
    photo: 'Foto {n}',
    close: 'Sluiten',
    enlarge: 'Vergroten',

    timelineTitle: 'Verloop',
    eventCreated: 'Zending aangemeld',
    eventAtDepot: 'Aangekomen in het depot',
    eventPlanned: 'Ingepland op een route',
    eventOnTheWay: 'Onderweg naar jou',
    eventRescheduled: 'Nieuwe datum gepland',
    eventCompletedDelivery: 'Bezorgd',
    eventCompletedPickup: 'Opgehaald',
    eventNotCompletedDelivery: 'Niet bezorgd',
    eventNotCompletedPickup: 'Ophaalpoging niet gelukt',
    eventOnHold: 'In bewaring genomen',
    eventCancelled: 'Geannuleerd',
    eventReturned: 'Retour afzender',
    eventManco: 'Manco',
    reasons: {
        nothome: 'Niet thuis',
        notready: 'Niet gereed',
        invalid: 'Voldoet niet aan de eisen',
        addressnotfound: 'Adres niet gevonden',
        wrongaddress: 'Adres onjuist',
        companyaddressclosed: 'Bedrijfsadres gesloten',
        verificationfailed: 'Verificatie niet gelukt',
        delayed: 'Te weinig tijd',
        overmacht: 'Overmacht',
        other: 'Andere reden',
        refused: 'Geweigerd'
    } as Record<TrackTraceReason, string>,

    detailsTitle: 'Zendinggegevens',
    sender: 'Afzender',
    reference: 'Referentie',
    parcelOf: 'Pakket {n} van {total}',
    colloExpected: 'Aangemeld',
    colloAtDepot: 'In depot',
    colloOnTheWay: 'Onderweg',
    colloCompletedDelivery: 'Bezorgd',
    colloCompletedPickup: 'Opgehaald',
    colloNotCompleted: 'Niet gelukt',
    colloOnHold: 'In bewaring',
    colloReturned: 'Retour',
    colloCancelled: 'Geannuleerd',
    colloMissing: 'Ontbreekt',

    helpTitle: 'Hulp nodig?',
    call: 'Bellen',
    whatsapp: 'WhatsApp',
    email: 'E-mail',
    emailSubject: 'Vraag over mijn zending {code}',
    faqTitle: 'Veelgestelde vragen',
    updatedAt: 'Bijgewerkt om {time}',
    actionsTitle: 'Pas je bezorging aan',
    actionsIntro: 'Niet thuis? Kies wat het beste uitkomt. Je bezorger ziet je keuze direct in de app.',
    safePlaceTitle: 'Veilige plek kiezen',
    safePlaceSub: 'Laat je pakket achter op een plek bij je huis',
    neighbourTitle: 'Bezorgen bij de buren',
    neighbourSub: 'Laat een buur je pakket aannemen',
    instructionsTitle: 'Instructie voor de bezorger',
    instructionsSub: 'Bijvoorbeeld: bel aan bij de zijdeur',
    blockedClosed: 'Niet meer mogelijk.',
    safePlaceOther: 'Anders',
    safePlaceNote: 'Omschrijving voor de bezorger',
    safePlaceNoteOptional: 'Omschrijving voor de bezorger (optioneel)',
    safePlaceNotePlaceholder: 'Bijv. achter de groene container',
    safePlaceDisclaimer: 'Ik weet dat mijn pakket zonder handtekening wordt achtergelaten. De bezorger maakt een foto.',
    safePlaceSave: 'Veilige plek opslaan',
    neighbourLabel: 'Huisnummer van de buren',
    neighbourPlaceholder: 'Bijv. 114',
    neighbourSave: 'Buren opslaan',
    instructionsLabel: 'Jouw instructie',
    instructionsPlaceholder: 'Bijv. bel aan bij de zijdeur, de bel aan de voorkant doet het niet',
    instructionsSave: 'Instructie opslaan',
    tileDeliveryDay: 'Andere dag',
    deliveryDayTitle: 'Andere bezorgdag kiezen',
    deliveryDayQuestion: 'Op welke dag wil je je pakket ontvangen?',
    choiceDeliveryDay: 'Nieuwe bezorgdag: {date}',
    yourChoice: 'Jouw keuze',
    choiceSafePlace: 'Veilige plek: {place}',
    choiceNeighbour: 'Bij de buren, huisnummer {nr}',
    yourInstructions: 'Jouw instructie',
    withdraw: 'Intrekken',
    change: 'Wijzigen',
    choiceDeliveryDayHint: 'Je kunt een andere dag kiezen tot je bezorging wordt voorbereid.',
    choiceChangeHint: 'Je kunt je keuze wijzigen tot je pakket bezorgd is.',
    saved: 'Opgeslagen. Je bezorger ziet dit direct in de app.',
    actionNotAllowed: 'Deze wijziging is niet meer mogelijk.',
    actionInvalid: 'Controleer wat je hebt ingevuld.',
    actionError: 'Opslaan is niet gelukt. Probeer het opnieuw.',
    subSafePlace: 'Achtergelaten op je veilige plek: {place}.',
    tileSafePlace: 'Veilige plek',
    tileNeighbour: 'Bij de buren',
    tilePickupPoint: 'Ophalen',
    tileInstructions: 'Instructie',
    pickupPointTitle: 'Ophalen bij {name}',
    safePlaceQuestion: 'Waar mag je pakket blijven?',
    pickupPointQuestion: 'Waar haal je je pakket op?',
    pickupPointNotice: 'Je pakket wordt niet meer bezorgd. Je kunt het ophalen tot {date}.',
    pickupPointChosen: 'Je kunt je pakket ophalen bij {name}, {address}, tot {date}.',
    pickupPointChosenNoAddress: 'Je kunt je pakket ophalen bij {name} tot {date}.',
    eyebrowPickupPoint: 'Klaar om op te halen',
    openingHours: 'Openingstijden',
    choicePickupPoint: 'Ophalen bij {name}',
    backToOptions: 'Terug naar andere opties',
    blockedNotAtDepot: 'Kan zodra je pakket bij ons in het depot is.',
    blockedNotPossible: 'Niet mogelijk voor deze zending.',
    morePackageInfo: 'Meer pakketinformatie',
    lessPackageInfo: 'Minder pakketinformatie',
    recipient: 'Ontvanger',
    mapTitle: 'Volg je bezorger',
    mapYourAddress: 'Jouw adres',
    mapCourier: 'Bezorger',
    mapStops: 'Nog {count} stops tot jouw adres.',
    mapStopsLabel: 'Nog {count} stops',
    mapEta: 'Verwacht rond {time}.',
    mapUpdated: 'Bijgewerkt om {time}.',
    mapOnlyToday: 'De bezorger is alleen zichtbaar op de dag van bezorging.',
    teamOf: 'Team {name}',
    carrierPhoto: 'Foto van {name}',

    messages: {
        pickupNotCompletedMessage: 'We konden je zending niet ophalen. We nemen contact met je op over een nieuwe afspraak.',
        pickupNotHomeMessage: 'We hebben je niet thuis getroffen en konden je zending niet ophalen. We nemen contact met je op over een nieuwe afspraak.',
        pickupCancelledMessage: 'Het ophalen van deze zending is geannuleerd.',
        deliveryNotCompletedRefusedMessage: 'De zending is geweigerd en gaat terug naar de afzender.',
        deliveryNotCompletedRetourMessage: 'We konden je zending niet bezorgen. De zending gaat terug naar de afzender.',
        deliveryNotCompletedNoFollowUpMessage: 'We konden je zending niet bezorgen. Neem contact met ons op om een nieuwe bezorging af te spreken.',
        deliveryNotCompletedRescheduleMessage: 'We konden je zending niet bezorgen. We plannen een nieuwe bezorgpoging in.',
        deliveryNotHomeRetourMessage: 'We hebben je niet thuis getroffen. De zending gaat terug naar de afzender.',
        deliveryNotHomeNoFollowUpMessage: 'We hebben je niet thuis getroffen. Neem contact met ons op om een nieuwe bezorging af te spreken.',
        deliveryNotHomeRescheduleMessage: 'We hebben je niet thuis getroffen. We plannen een nieuwe bezorgpoging in.',
        deliveryNotHomeOnHoldMessage: 'We bewaren je zending in ons depot. Neem contact met ons op om een nieuwe bezorging af te spreken.',
        deliveryMancoMessage: 'Je zending is niet bij ons aangekomen. Neem contact op met de afzender.',
        deliveryCancelledMessage: 'De bezorging van deze zending is geannuleerd.'
    } as Record<TrackTraceMessageKey, string>
}

type Dictionary = typeof nl

const en: Dictionary = {
    languageName: 'English',
    changeLanguage: 'Change language',
    loading: 'Loading your shipment…',
    notFoundTitle: 'Shipment not found',
    notFoundText: 'We can’t find a shipment with this tracking code. Please check the code and try again.',
    errorTitle: 'Something went wrong',
    errorText: 'We couldn’t load your shipment right now. Please try again in a few minutes.',
    retry: 'Try again',
    trackTraceCode: 'Tracking code',
    search: 'Search',

    stepsDelivery: ['Registered', 'Scheduled', 'On its way', 'Delivered'],
    stepsPickup: ['Registered', 'Scheduled', 'On its way', 'Collected'],
    stepOf: 'Step {step} of {total}',

    eyebrowExpected: 'Your shipment is registered',
    eyebrowScheduledDelivery: 'Expected delivery',
    eyebrowScheduledPickup: 'Expected collection',
    eyebrowOnTheWayDelivery: 'On its way to you',
    eyebrowOnTheWayPickup: 'On the way to collect',
    eyebrowCompletedDelivery: 'Delivered',
    eyebrowCompletedPickup: 'Collected',
    eyebrowNotCompletedDelivery: 'Delivery unsuccessful',
    eyebrowNotCompletedPickup: 'Collection unsuccessful',
    eyebrowReturning: 'Returning to sender',
    eyebrowOnHold: 'On hold',
    eyebrowCancelled: 'Cancelled',

    titleDateUnknown: 'Date to follow',
    titleCompletedAt: '{date} at {time}',
    titleNotCompleted: 'We missed you',
    titleAttemptFailed: 'Attempt unsuccessful',
    titleReturning: 'Back to the sender',
    titleOnHoldUntil: 'Until {date}',
    titleCancelled: 'Shipment cancelled',

    subExpected: 'We’ll let you know when your shipment is scheduled.',
    subWindow: 'Between {from} and {to}',
    subOnTheWay: 'Your shipment is on its way today.',
    subCompletedDelivery: 'Your shipment has been delivered.',
    subCompletedPickup: 'Your shipment has been collected.',
    subNeighbour: 'Left with the neighbours at number {nr}.',
    subNeighbourUnknown: 'Left with the neighbours.',
    subMailbox: 'Delivered through the letterbox.',

    today: 'today',
    tomorrow: 'tomorrow',
    yesterday: 'yesterday',

    windowLabel: 'Time slot',
    dateLabel: 'Date',
    deliveryAddress: 'Delivery address',
    pickupAddress: 'Collection address',
    shipment: 'Shipment',
    shipmentFrom: '{count} from {sender}',
    parcels: ['{count} parcel', '{count} parcels'],

    requirementsTitle: 'Good to know',
    reqSignature: 'A signature is required on delivery.',
    reqStatedAddressOnly: 'We only deliver to this address, not to neighbours.',
    reqMailbox: 'Your shipment fits through the letterbox.',
    reqMinimumAge: 'The recipient must be at least {age} years old.',
    reqIdCheck: 'Please have a valid ID ready.',
    reqVerificationCode: 'You need a delivery code to receive this shipment.',

    incompleteLink: 'This link is incomplete. Please use the link from your email.',
    searchTitle: 'Track your shipment',
    searchText: 'Enter the Track & Trace code and the postal code of the address.',
    postalCode: 'Postal code',
    confirm: 'Confirm',
    tooManyAttempts: 'Too many attempts. Please try again in 15 minutes.',

    proofTitleDelivery: 'Proof of delivery',
    proofTitlePickup: 'Proof of collection',
    signee: 'Received by',
    signature: 'Signature',
    photo: 'Photo {n}',
    close: 'Close',
    enlarge: 'Enlarge',

    timelineTitle: 'History',
    eventCreated: 'Shipment registered',
    eventAtDepot: 'Arrived at the depot',
    eventPlanned: 'Scheduled on a route',
    eventOnTheWay: 'On its way to you',
    eventRescheduled: 'New date scheduled',
    eventCompletedDelivery: 'Delivered',
    eventCompletedPickup: 'Collected',
    eventNotCompletedDelivery: 'Not delivered',
    eventNotCompletedPickup: 'Collection attempt unsuccessful',
    eventOnHold: 'Put on hold',
    eventCancelled: 'Cancelled',
    eventReturned: 'Returned to sender',
    eventManco: 'Missing',
    reasons: {
        nothome: 'Not at home',
        notready: 'Not ready',
        invalid: 'Does not meet the requirements',
        addressnotfound: 'Address not found',
        wrongaddress: 'Incorrect address',
        companyaddressclosed: 'Business address closed',
        verificationfailed: 'Verification failed',
        delayed: 'Out of time',
        overmacht: 'Force majeure',
        other: 'Other reason',
        refused: 'Refused'
    },

    detailsTitle: 'Shipment details',
    sender: 'Sender',
    reference: 'Reference',
    parcelOf: 'Parcel {n} of {total}',
    colloExpected: 'Registered',
    colloAtDepot: 'At depot',
    colloOnTheWay: 'On its way',
    colloCompletedDelivery: 'Delivered',
    colloCompletedPickup: 'Collected',
    colloNotCompleted: 'Unsuccessful',
    colloOnHold: 'On hold',
    colloReturned: 'Returned',
    colloCancelled: 'Cancelled',
    colloMissing: 'Missing',

    helpTitle: 'Need help?',
    call: 'Call',
    whatsapp: 'WhatsApp',
    email: 'Email',
    emailSubject: 'Question about my shipment {code}',
    faqTitle: 'Frequently asked questions',
    updatedAt: 'Updated at {time}',
    actionsTitle: 'Change your delivery',
    actionsIntro: 'Not at home? Choose what suits you best. Your courier sees your choice in the app right away.',
    safePlaceTitle: 'Choose a safe place',
    safePlaceSub: 'Have your parcel left somewhere at your home',
    neighbourTitle: 'Deliver to a neighbour',
    neighbourSub: 'Let a neighbour accept your parcel',
    instructionsTitle: 'Instructions for the courier',
    instructionsSub: 'For example: ring the side door',
    blockedClosed: 'No longer possible.',
    safePlaceOther: 'Other',
    safePlaceNote: 'Description for the courier',
    safePlaceNoteOptional: 'Description for the courier (optional)',
    safePlaceNotePlaceholder: 'E.g. behind the green bin',
    safePlaceDisclaimer: 'I understand that my parcel is left without a signature. The courier takes a photo.',
    safePlaceSave: 'Save safe place',
    neighbourLabel: 'House number of the neighbour',
    neighbourPlaceholder: 'E.g. 114',
    neighbourSave: 'Save neighbour',
    instructionsLabel: 'Your instructions',
    instructionsPlaceholder: 'E.g. ring the side door, the front bell doesn’t work',
    instructionsSave: 'Save instructions',
    tileDeliveryDay: 'Other day',
    deliveryDayTitle: 'Choose another delivery day',
    deliveryDayQuestion: 'On which day would you like to receive your parcel?',
    choiceDeliveryDay: 'New delivery day: {date}',
    yourChoice: 'Your choice',
    choiceSafePlace: 'Safe place: {place}',
    choiceNeighbour: 'Neighbour, house number {nr}',
    yourInstructions: 'Your instructions',
    withdraw: 'Withdraw',
    change: 'Change',
    choiceDeliveryDayHint: 'You can choose another day until your delivery is being prepared.',
    choiceChangeHint: 'You can change your choice until your parcel is delivered.',
    saved: 'Saved. Your courier sees this in the app right away.',
    actionNotAllowed: 'This change is no longer possible.',
    actionInvalid: 'Please check what you entered.',
    actionError: 'Saving failed. Please try again.',
    subSafePlace: 'Left at your safe place: {place}.',
    tileSafePlace: 'Safe place',
    tileNeighbour: 'Neighbours',
    tilePickupPoint: 'Collect',
    tileInstructions: 'Instruction',
    pickupPointTitle: 'Collect at {name}',
    safePlaceQuestion: 'Where may your parcel be left?',
    pickupPointQuestion: 'Where will you collect your parcel?',
    pickupPointNotice: 'Your parcel will no longer be delivered. You can collect it until {date}.',
    pickupPointChosen: 'You can collect your parcel at {name}, {address}, until {date}.',
    pickupPointChosenNoAddress: 'You can collect your parcel at {name} until {date}.',
    eyebrowPickupPoint: 'Ready to collect',
    openingHours: 'Opening hours',
    choicePickupPoint: 'Collect at {name}',
    backToOptions: 'Back to other options',
    blockedNotAtDepot: 'Possible once your parcel is at our depot.',
    blockedNotPossible: 'Not possible for this shipment.',
    morePackageInfo: 'More parcel information',
    lessPackageInfo: 'Less parcel information',
    recipient: 'Recipient',
    mapTitle: 'Follow your courier',
    mapYourAddress: 'Your address',
    mapCourier: 'Courier',
    mapStops: '{count} more stops before your address.',
    mapStopsLabel: '{count} stops to go',
    mapEta: 'Expected around {time}.',
    mapUpdated: 'Updated at {time}.',
    mapOnlyToday: 'The courier is only visible on the day of delivery.',
    teamOf: 'Team {name}',
    carrierPhoto: 'Photo of {name}',

    messages: {
        pickupNotCompletedMessage: 'We couldn’t collect your shipment. We’ll contact you to arrange a new appointment.',
        pickupNotHomeMessage: 'You weren’t home and we couldn’t collect your shipment. We’ll contact you to arrange a new appointment.',
        pickupCancelledMessage: 'The collection of this shipment has been cancelled.',
        deliveryNotCompletedRefusedMessage: 'The shipment was refused and is returning to the sender.',
        deliveryNotCompletedRetourMessage: 'We couldn’t deliver your shipment. It is returning to the sender.',
        deliveryNotCompletedNoFollowUpMessage: 'We couldn’t deliver your shipment. Please contact us to arrange a new delivery.',
        deliveryNotCompletedRescheduleMessage: 'We couldn’t deliver your shipment. We’ll schedule a new delivery attempt.',
        deliveryNotHomeRetourMessage: 'You weren’t home. The shipment is returning to the sender.',
        deliveryNotHomeNoFollowUpMessage: 'You weren’t home. Please contact us to arrange a new delivery.',
        deliveryNotHomeRescheduleMessage: 'You weren’t home. We’ll schedule a new delivery attempt.',
        deliveryNotHomeOnHoldMessage: 'We’re keeping your shipment at our depot. Please contact us to arrange a new delivery.',
        deliveryMancoMessage: 'Your shipment never reached us. Please contact the sender.',
        deliveryCancelledMessage: 'The delivery of this shipment has been cancelled.'
    }
}

const de: Dictionary = {
    languageName: 'Deutsch',
    changeLanguage: 'Sprache ändern',
    loading: 'Deine Sendung wird geladen…',
    notFoundTitle: 'Sendung nicht gefunden',
    notFoundText: 'Wir finden keine Sendung mit dieser Sendungsnummer. Bitte prüfe die Nummer und versuche es erneut.',
    errorTitle: 'Etwas ist schiefgelaufen',
    errorText: 'Wir konnten deine Sendung gerade nicht laden. Bitte versuche es in ein paar Minuten erneut.',
    retry: 'Erneut versuchen',
    trackTraceCode: 'Sendungsnummer',
    search: 'Suchen',

    stepsDelivery: ['Angemeldet', 'Eingeplant', 'Unterwegs', 'Zugestellt'],
    stepsPickup: ['Angemeldet', 'Eingeplant', 'Unterwegs', 'Abgeholt'],
    stepOf: 'Schritt {step} von {total}',

    eyebrowExpected: 'Deine Sendung ist angemeldet',
    eyebrowScheduledDelivery: 'Voraussichtliche Zustellung',
    eyebrowScheduledPickup: 'Voraussichtliche Abholung',
    eyebrowOnTheWayDelivery: 'Unterwegs zu dir',
    eyebrowOnTheWayPickup: 'Unterwegs zur Abholung',
    eyebrowCompletedDelivery: 'Zugestellt',
    eyebrowCompletedPickup: 'Abgeholt',
    eyebrowNotCompletedDelivery: 'Zustellung nicht erfolgreich',
    eyebrowNotCompletedPickup: 'Abholung nicht erfolgreich',
    eyebrowReturning: 'Rücksendung an Absender',
    eyebrowOnHold: 'In Verwahrung',
    eyebrowCancelled: 'Storniert',

    titleDateUnknown: 'Datum folgt',
    titleCompletedAt: '{date} um {time}',
    titleNotCompleted: 'Wir haben dich verpasst',
    titleAttemptFailed: 'Versuch nicht erfolgreich',
    titleReturning: 'Zurück zum Absender',
    titleOnHoldUntil: 'Bis {date}',
    titleCancelled: 'Sendung storniert',

    subExpected: 'Wir informieren dich, sobald deine Sendung eingeplant ist.',
    subWindow: 'Zwischen {from} und {to}',
    subOnTheWay: 'Deine Sendung ist heute unterwegs.',
    subCompletedDelivery: 'Deine Sendung wurde zugestellt.',
    subCompletedPickup: 'Deine Sendung wurde abgeholt.',
    subNeighbour: 'Beim Nachbarn in Hausnummer {nr} abgegeben.',
    subNeighbourUnknown: 'Beim Nachbarn abgegeben.',
    subMailbox: 'In den Briefkasten zugestellt.',

    today: 'heute',
    tomorrow: 'morgen',
    yesterday: 'gestern',

    windowLabel: 'Zeitfenster',
    dateLabel: 'Datum',
    deliveryAddress: 'Lieferadresse',
    pickupAddress: 'Abholadresse',
    shipment: 'Sendung',
    shipmentFrom: '{count} von {sender}',
    parcels: ['{count} Paket', '{count} Pakete'],

    requirementsTitle: 'Gut zu wissen',
    reqSignature: 'Für die Annahme ist eine Unterschrift erforderlich.',
    reqStatedAddressOnly: 'Wir liefern nur an diese Adresse, nicht an Nachbarn.',
    reqMailbox: 'Deine Sendung passt in den Briefkasten.',
    reqMinimumAge: 'Der Empfänger muss mindestens {age} Jahre alt sein.',
    reqIdCheck: 'Bitte halte einen gültigen Ausweis bereit.',
    reqVerificationCode: 'Für die Annahme brauchst du einen Zustellcode.',

    incompleteLink: 'Dieser Link ist unvollständig. Bitte verwende den Link aus deiner E-Mail.',
    searchTitle: 'Sendung verfolgen',
    searchText: 'Gib den Track & Trace-Code und die Postleitzahl der Adresse ein.',
    postalCode: 'Postleitzahl',
    confirm: 'Bestätigen',
    tooManyAttempts: 'Zu viele Versuche. Bitte versuche es in 15 Minuten erneut.',

    proofTitleDelivery: 'Zustellnachweis',
    proofTitlePickup: 'Abholnachweis',
    signee: 'Empfangen von',
    signature: 'Unterschrift',
    photo: 'Foto {n}',
    close: 'Schließen',
    enlarge: 'Vergrößern',

    timelineTitle: 'Verlauf',
    eventCreated: 'Sendung angemeldet',
    eventAtDepot: 'Im Depot angekommen',
    eventPlanned: 'Auf einer Route eingeplant',
    eventOnTheWay: 'Unterwegs zu dir',
    eventRescheduled: 'Neues Datum geplant',
    eventCompletedDelivery: 'Zugestellt',
    eventCompletedPickup: 'Abgeholt',
    eventNotCompletedDelivery: 'Nicht zugestellt',
    eventNotCompletedPickup: 'Abholversuch nicht erfolgreich',
    eventOnHold: 'In Verwahrung genommen',
    eventCancelled: 'Storniert',
    eventReturned: 'Zurück an den Absender',
    eventManco: 'Fehlt',
    reasons: {
        nothome: 'Nicht zu Hause',
        notready: 'Nicht bereit',
        invalid: 'Erfüllt die Anforderungen nicht',
        addressnotfound: 'Adresse nicht gefunden',
        wrongaddress: 'Adresse falsch',
        companyaddressclosed: 'Geschäftsadresse geschlossen',
        verificationfailed: 'Verifizierung fehlgeschlagen',
        delayed: 'Zeitmangel',
        overmacht: 'Höhere Gewalt',
        other: 'Anderer Grund',
        refused: 'Verweigert'
    },

    detailsTitle: 'Sendungsdetails',
    sender: 'Absender',
    reference: 'Referenz',
    parcelOf: 'Paket {n} von {total}',
    colloExpected: 'Angemeldet',
    colloAtDepot: 'Im Depot',
    colloOnTheWay: 'Unterwegs',
    colloCompletedDelivery: 'Zugestellt',
    colloCompletedPickup: 'Abgeholt',
    colloNotCompleted: 'Nicht erfolgreich',
    colloOnHold: 'In Verwahrung',
    colloReturned: 'Retour',
    colloCancelled: 'Storniert',
    colloMissing: 'Fehlt',

    helpTitle: 'Brauchst du Hilfe?',
    call: 'Anrufen',
    whatsapp: 'WhatsApp',
    email: 'E-Mail',
    emailSubject: 'Frage zu meiner Sendung {code}',
    faqTitle: 'Häufige Fragen',
    updatedAt: 'Aktualisiert um {time}',
    actionsTitle: 'Zustellung anpassen',
    actionsIntro: 'Nicht zu Hause? Wähle, was am besten passt. Dein Zusteller sieht deine Wahl sofort in der App.',
    safePlaceTitle: 'Ablageort wählen',
    safePlaceSub: 'Lass dein Paket an einem Ort bei deinem Haus ablegen',
    neighbourTitle: 'Beim Nachbarn abgeben',
    neighbourSub: 'Lass einen Nachbarn dein Paket annehmen',
    instructionsTitle: 'Hinweis für den Zusteller',
    instructionsSub: 'Zum Beispiel: an der Seitentür klingeln',
    blockedClosed: 'Nicht mehr möglich.',
    safePlaceOther: 'Sonstiges',
    safePlaceNote: 'Beschreibung für den Zusteller',
    safePlaceNoteOptional: 'Beschreibung für den Zusteller (optional)',
    safePlaceNotePlaceholder: 'Z. B. hinter der grünen Tonne',
    safePlaceDisclaimer: 'Ich weiß, dass mein Paket ohne Unterschrift abgelegt wird. Der Zusteller macht ein Foto.',
    safePlaceSave: 'Ablageort speichern',
    neighbourLabel: 'Hausnummer des Nachbarn',
    neighbourPlaceholder: 'Z. B. 114',
    neighbourSave: 'Nachbarn speichern',
    instructionsLabel: 'Dein Hinweis',
    instructionsPlaceholder: 'Z. B. an der Seitentür klingeln, die vordere Klingel geht nicht',
    instructionsSave: 'Hinweis speichern',
    tileDeliveryDay: 'Anderer Tag',
    deliveryDayTitle: 'Anderen Zustelltag wählen',
    deliveryDayQuestion: 'An welchem Tag möchtest du dein Paket erhalten?',
    choiceDeliveryDay: 'Neuer Zustelltag: {date}',
    yourChoice: 'Deine Wahl',
    choiceSafePlace: 'Ablageort: {place}',
    choiceNeighbour: 'Nachbar, Hausnummer {nr}',
    yourInstructions: 'Dein Hinweis',
    withdraw: 'Zurückziehen',
    change: 'Ändern',
    choiceDeliveryDayHint: 'Du kannst einen anderen Tag wählen, bis deine Zustellung vorbereitet wird.',
    choiceChangeHint: 'Du kannst deine Wahl ändern, bis dein Paket zugestellt ist.',
    saved: 'Gespeichert. Dein Zusteller sieht das sofort in der App.',
    actionNotAllowed: 'Diese Änderung ist nicht mehr möglich.',
    actionInvalid: 'Bitte prüfe deine Eingabe.',
    actionError: 'Speichern fehlgeschlagen. Bitte versuche es erneut.',
    subSafePlace: 'An deinem Ablageort abgelegt: {place}.',
    tileSafePlace: 'Ablageort',
    tileNeighbour: 'Nachbarn',
    tilePickupPoint: 'Abholen',
    tileInstructions: 'Hinweis',
    pickupPointTitle: 'Abholen bei {name}',
    safePlaceQuestion: 'Wo darf dein Paket bleiben?',
    pickupPointQuestion: 'Wo holst du dein Paket ab?',
    pickupPointNotice: 'Dein Paket wird nicht mehr zugestellt. Du kannst es bis {date} abholen.',
    pickupPointChosen: 'Du kannst dein Paket bei {name}, {address}, bis {date} abholen.',
    pickupPointChosenNoAddress: 'Du kannst dein Paket bei {name} bis {date} abholen.',
    eyebrowPickupPoint: 'Bereit zur Abholung',
    openingHours: 'Öffnungszeiten',
    choicePickupPoint: 'Abholen bei {name}',
    backToOptions: 'Zurück zu den anderen Optionen',
    blockedNotAtDepot: 'Möglich, sobald dein Paket in unserem Depot ist.',
    blockedNotPossible: 'Für diese Sendung nicht möglich.',
    morePackageInfo: 'Mehr Paketinformationen',
    lessPackageInfo: 'Weniger Paketinformationen',
    recipient: 'Empfänger',
    mapTitle: 'Verfolge deinen Zusteller',
    mapYourAddress: 'Deine Adresse',
    mapCourier: 'Zusteller',
    mapStops: 'Noch {count} Stopps bis zu deiner Adresse.',
    mapStopsLabel: 'Noch {count} Stopps',
    mapEta: 'Erwartet gegen {time}.',
    mapUpdated: 'Aktualisiert um {time}.',
    mapOnlyToday: 'Der Zusteller ist nur am Zustelltag sichtbar.',
    teamOf: 'Team {name}',
    carrierPhoto: 'Foto von {name}',

    messages: {
        pickupNotCompletedMessage: 'Wir konnten deine Sendung nicht abholen. Wir melden uns für einen neuen Termin.',
        pickupNotHomeMessage: 'Wir haben dich nicht angetroffen und konnten deine Sendung nicht abholen. Wir melden uns für einen neuen Termin.',
        pickupCancelledMessage: 'Die Abholung dieser Sendung wurde storniert.',
        deliveryNotCompletedRefusedMessage: 'Die Sendung wurde verweigert und geht zurück an den Absender.',
        deliveryNotCompletedRetourMessage: 'Wir konnten deine Sendung nicht zustellen. Sie geht zurück an den Absender.',
        deliveryNotCompletedNoFollowUpMessage: 'Wir konnten deine Sendung nicht zustellen. Bitte kontaktiere uns für eine neue Zustellung.',
        deliveryNotCompletedRescheduleMessage: 'Wir konnten deine Sendung nicht zustellen. Wir planen einen neuen Zustellversuch ein.',
        deliveryNotHomeRetourMessage: 'Wir haben dich nicht angetroffen. Die Sendung geht zurück an den Absender.',
        deliveryNotHomeNoFollowUpMessage: 'Wir haben dich nicht angetroffen. Bitte kontaktiere uns für eine neue Zustellung.',
        deliveryNotHomeRescheduleMessage: 'Wir haben dich nicht angetroffen. Wir planen einen neuen Zustellversuch ein.',
        deliveryNotHomeOnHoldMessage: 'Wir bewahren deine Sendung in unserem Depot auf. Bitte kontaktiere uns für eine neue Zustellung.',
        deliveryMancoMessage: 'Deine Sendung ist nicht bei uns angekommen. Bitte wende dich an den Absender.',
        deliveryCancelledMessage: 'Die Zustellung dieser Sendung wurde storniert.'
    }
}

const fr: Dictionary = {
    languageName: 'Français',
    changeLanguage: 'Changer de langue',
    loading: 'Chargement de votre envoi…',
    notFoundTitle: 'Envoi introuvable',
    notFoundText: 'Nous ne trouvons aucun envoi avec ce code de suivi. Vérifiez le code et réessayez.',
    errorTitle: 'Un problème est survenu',
    errorText: 'Nous n’avons pas pu charger votre envoi. Réessayez dans quelques minutes.',
    retry: 'Réessayer',
    trackTraceCode: 'Code de suivi',
    search: 'Rechercher',

    stepsDelivery: ['Enregistré', 'Planifié', 'En route', 'Livré'],
    stepsPickup: ['Enregistré', 'Planifié', 'En route', 'Collecté'],
    stepOf: 'Étape {step} sur {total}',

    eyebrowExpected: 'Votre envoi est enregistré',
    eyebrowScheduledDelivery: 'Livraison prévue',
    eyebrowScheduledPickup: 'Collecte prévue',
    eyebrowOnTheWayDelivery: 'En route vers vous',
    eyebrowOnTheWayPickup: 'En route pour la collecte',
    eyebrowCompletedDelivery: 'Livré',
    eyebrowCompletedPickup: 'Collecté',
    eyebrowNotCompletedDelivery: 'Livraison non effectuée',
    eyebrowNotCompletedPickup: 'Collecte non effectuée',
    eyebrowReturning: 'Retour à l’expéditeur',
    eyebrowOnHold: 'En consigne',
    eyebrowCancelled: 'Annulé',

    titleDateUnknown: 'Date à venir',
    titleCompletedAt: '{date} à {time}',
    titleNotCompleted: 'Nous vous avons manqué',
    titleAttemptFailed: 'Tentative échouée',
    titleReturning: 'Retour à l’expéditeur',
    titleOnHoldUntil: 'Jusqu’au {date}',
    titleCancelled: 'Envoi annulé',

    subExpected: 'Nous vous préviendrons dès que votre envoi sera planifié.',
    subWindow: 'Entre {from} et {to}',
    subOnTheWay: 'Votre envoi est en route aujourd’hui.',
    subCompletedDelivery: 'Votre envoi a été livré.',
    subCompletedPickup: 'Votre envoi a été collecté.',
    subNeighbour: 'Remis chez le voisin au numéro {nr}.',
    subNeighbourUnknown: 'Remis chez un voisin.',
    subMailbox: 'Livré dans la boîte aux lettres.',

    today: 'aujourd’hui',
    tomorrow: 'demain',
    yesterday: 'hier',

    windowLabel: 'Créneau',
    dateLabel: 'Date',
    deliveryAddress: 'Adresse de livraison',
    pickupAddress: 'Adresse de collecte',
    shipment: 'Envoi',
    shipmentFrom: '{count} de {sender}',
    parcels: ['{count} colis', '{count} colis'],

    requirementsTitle: 'Bon à savoir',
    reqSignature: 'Une signature est requise à la réception.',
    reqStatedAddressOnly: 'Nous livrons uniquement à cette adresse, pas chez les voisins.',
    reqMailbox: 'Votre envoi passe dans la boîte aux lettres.',
    reqMinimumAge: 'Le destinataire doit avoir au moins {age} ans.',
    reqIdCheck: 'Préparez une pièce d’identité valide.',
    reqVerificationCode: 'Un code de livraison est nécessaire pour la réception.',

    incompleteLink: 'Ce lien est incomplet. Utilisez le lien de votre e-mail.',
    searchTitle: 'Suivre votre envoi',
    searchText: 'Saisissez le code Track & Trace et le code postal de l’adresse.',
    postalCode: 'Code postal',
    confirm: 'Confirmer',
    tooManyAttempts: 'Trop de tentatives. Réessayez dans 15 minutes.',

    proofTitleDelivery: 'Preuve de livraison',
    proofTitlePickup: 'Preuve de collecte',
    signee: 'Reçu par',
    signature: 'Signature',
    photo: 'Photo {n}',
    close: 'Fermer',
    enlarge: 'Agrandir',

    timelineTitle: 'Historique',
    eventCreated: 'Envoi enregistré',
    eventAtDepot: 'Arrivé au dépôt',
    eventPlanned: 'Planifié sur une tournée',
    eventOnTheWay: 'En route vers vous',
    eventRescheduled: 'Nouvelle date planifiée',
    eventCompletedDelivery: 'Livré',
    eventCompletedPickup: 'Collecté',
    eventNotCompletedDelivery: 'Non livré',
    eventNotCompletedPickup: 'Tentative de collecte échouée',
    eventOnHold: 'Mis en consigne',
    eventCancelled: 'Annulé',
    eventReturned: 'Retour à l’expéditeur',
    eventManco: 'Manquant',
    reasons: {
        nothome: 'Absent',
        notready: 'Pas prêt',
        invalid: 'Ne répond pas aux exigences',
        addressnotfound: 'Adresse introuvable',
        wrongaddress: 'Adresse incorrecte',
        companyaddressclosed: 'Adresse professionnelle fermée',
        verificationfailed: 'Vérification échouée',
        delayed: 'Manque de temps',
        overmacht: 'Force majeure',
        other: 'Autre raison',
        refused: 'Refusé'
    },

    detailsTitle: 'Détails de l’envoi',
    sender: 'Expéditeur',
    reference: 'Référence',
    parcelOf: 'Colis {n} sur {total}',
    colloExpected: 'Enregistré',
    colloAtDepot: 'Au dépôt',
    colloOnTheWay: 'En route',
    colloCompletedDelivery: 'Livré',
    colloCompletedPickup: 'Collecté',
    colloNotCompleted: 'Échoué',
    colloOnHold: 'En consigne',
    colloReturned: 'Retourné',
    colloCancelled: 'Annulé',
    colloMissing: 'Manquant',

    helpTitle: 'Besoin d’aide ?',
    call: 'Appeler',
    whatsapp: 'WhatsApp',
    email: 'E-mail',
    emailSubject: 'Question sur mon envoi {code}',
    faqTitle: 'Questions fréquentes',
    updatedAt: 'Mis à jour à {time}',
    actionsTitle: 'Modifier votre livraison',
    actionsIntro: 'Absent ? Choisissez ce qui vous convient le mieux. Votre livreur voit votre choix directement dans l’app.',
    safePlaceTitle: 'Choisir un lieu sûr',
    safePlaceSub: 'Faites déposer votre colis à un endroit chez vous',
    neighbourTitle: 'Livrer chez un voisin',
    neighbourSub: 'Un voisin réceptionne votre colis',
    instructionsTitle: 'Instructions pour le livreur',
    instructionsSub: 'Par exemple : sonner à la porte latérale',
    blockedClosed: 'Plus possible.',
    safePlaceOther: 'Autre',
    safePlaceNote: 'Description pour le livreur',
    safePlaceNoteOptional: 'Description pour le livreur (facultatif)',
    safePlaceNotePlaceholder: 'Par ex. derrière la poubelle verte',
    safePlaceDisclaimer: 'Je sais que mon colis sera déposé sans signature. Le livreur prend une photo.',
    safePlaceSave: 'Enregistrer le lieu sûr',
    neighbourLabel: 'Numéro du voisin',
    neighbourPlaceholder: 'Par ex. 114',
    neighbourSave: 'Enregistrer le voisin',
    instructionsLabel: 'Vos instructions',
    instructionsPlaceholder: 'Par ex. sonner à la porte latérale, la sonnette avant ne marche pas',
    instructionsSave: 'Enregistrer les instructions',
    tileDeliveryDay: 'Autre jour',
    deliveryDayTitle: 'Choisir un autre jour de livraison',
    deliveryDayQuestion: 'Quel jour souhaitez-vous recevoir votre colis ?',
    choiceDeliveryDay: 'Nouveau jour de livraison : {date}',
    yourChoice: 'Votre choix',
    choiceSafePlace: 'Lieu sûr : {place}',
    choiceNeighbour: 'Voisin, numéro {nr}',
    yourInstructions: 'Vos instructions',
    withdraw: 'Retirer',
    change: 'Modifier',
    choiceDeliveryDayHint: 'Vous pouvez choisir un autre jour jusqu’à la préparation de votre livraison.',
    choiceChangeHint: 'Vous pouvez modifier votre choix jusqu’à la livraison de votre colis.',
    saved: 'Enregistré. Votre livreur le voit immédiatement dans l’application.',
    actionNotAllowed: 'Cette modification n’est plus possible.',
    actionInvalid: 'Vérifiez ce que vous avez saisi.',
    actionError: 'L’enregistrement a échoué. Réessayez.',
    subSafePlace: 'Déposé à votre lieu sûr : {place}.',
    tileSafePlace: 'Lieu sûr',
    tileNeighbour: 'Voisins',
    tilePickupPoint: 'Retrait',
    tileInstructions: 'Instruction',
    pickupPointTitle: 'Retrait chez {name}',
    safePlaceQuestion: 'Où votre colis peut-il être déposé ?',
    pickupPointQuestion: 'Où retirerez-vous votre colis ?',
    pickupPointNotice: 'Votre colis ne sera plus livré. Vous pouvez le retirer jusqu’au {date}.',
    pickupPointChosen: 'Vous pouvez retirer votre colis chez {name}, {address}, jusqu’au {date}.',
    pickupPointChosenNoAddress: 'Vous pouvez retirer votre colis chez {name} jusqu’au {date}.',
    eyebrowPickupPoint: 'Prêt à être retiré',
    openingHours: 'Horaires d’ouverture',
    choicePickupPoint: 'Retrait chez {name}',
    backToOptions: 'Retour aux autres options',
    blockedNotAtDepot: 'Possible dès que votre colis est à notre dépôt.',
    blockedNotPossible: 'Impossible pour cet envoi.',
    morePackageInfo: 'Plus d’informations sur le colis',
    lessPackageInfo: 'Moins d’informations sur le colis',
    recipient: 'Destinataire',
    mapTitle: 'Suivez votre livreur',
    mapYourAddress: 'Votre adresse',
    mapCourier: 'Livreur',
    mapStops: 'Encore {count} arrêts avant votre adresse.',
    mapStopsLabel: 'Encore {count} arrêts',
    mapEta: 'Prévu vers {time}.',
    mapUpdated: 'Mis à jour à {time}.',
    mapOnlyToday: 'Le livreur n’est visible que le jour de la livraison.',
    teamOf: 'L’équipe {name}',
    carrierPhoto: 'Photo de {name}',

    messages: {
        pickupNotCompletedMessage: 'Nous n’avons pas pu collecter votre envoi. Nous vous contacterons pour fixer un nouveau rendez-vous.',
        pickupNotHomeMessage: 'Vous étiez absent et nous n’avons pas pu collecter votre envoi. Nous vous contacterons pour fixer un nouveau rendez-vous.',
        pickupCancelledMessage: 'La collecte de cet envoi a été annulée.',
        deliveryNotCompletedRefusedMessage: 'L’envoi a été refusé et retourne à l’expéditeur.',
        deliveryNotCompletedRetourMessage: 'Nous n’avons pas pu livrer votre envoi. Il retourne à l’expéditeur.',
        deliveryNotCompletedNoFollowUpMessage: 'Nous n’avons pas pu livrer votre envoi. Contactez-nous pour convenir d’une nouvelle livraison.',
        deliveryNotCompletedRescheduleMessage: 'Nous n’avons pas pu livrer votre envoi. Nous planifions une nouvelle tentative.',
        deliveryNotHomeRetourMessage: 'Vous étiez absent. L’envoi retourne à l’expéditeur.',
        deliveryNotHomeNoFollowUpMessage: 'Vous étiez absent. Contactez-nous pour convenir d’une nouvelle livraison.',
        deliveryNotHomeRescheduleMessage: 'Vous étiez absent. Nous planifions une nouvelle tentative de livraison.',
        deliveryNotHomeOnHoldMessage: 'Nous conservons votre envoi dans notre dépôt. Contactez-nous pour convenir d’une nouvelle livraison.',
        deliveryMancoMessage: 'Votre envoi ne nous est jamais parvenu. Veuillez contacter l’expéditeur.',
        deliveryCancelledMessage: 'La livraison de cet envoi a été annulée.'
    }
}

const dictionaries: Record<TrackTraceLanguage, Dictionary> = {nl, en, de, fr}

const locales: Record<TrackTraceLanguage, string> = {nl: 'nl-NL', en: 'en-GB', de: 'de-DE', fr: 'fr-FR'}

type TextKey = {[K in keyof Dictionary]: Dictionary[K] extends string ? K : never}[keyof Dictionary]

export type Translator = {
    language: TrackTraceLanguage
    dict: Dictionary
    t: (key: TextKey, vars?: Record<string, string | number>) => string
    plural: (forms: string[], count: number) => string
    date: (date: string) => string
    relativeDate: (date: string) => string
    dateTime: (timestamp: string) => string
    time: (date: Date) => string
}

function fill(text: string, vars?: Record<string, string | number>) {
    return vars ? text.replace(/\{(\w+)\}/g, (match, name) => name in vars ? String(vars[name]) : match) : text
}

// YYYY-MM-DD as a local date, new Date('YYYY-MM-DD') would be UTC midnight
function parseDate(date: string): Date {
    const [year, month, day] = date.split('-').map(Number)
    return new Date(year, month - 1, day)
}

function dayDifference(date: string): number {
    const today = new Date()
    today.setHours(0, 0, 0, 0)
    return Math.round((parseDate(date).getTime() - today.getTime()) / 86400000)
}

export function translator(language: TrackTraceLanguage): Translator {
    const dict = dictionaries[language] || nl
    const locale = locales[language] || locales.nl

    const date = (value: string) => new Intl.DateTimeFormat(locale, {weekday: 'long', day: 'numeric', month: 'long'}).format(parseDate(value))

    const relativeDate = (value: string) => {
        const difference = dayDifference(value)
        const relative = difference === 0 ? dict.today : difference === 1 ? dict.tomorrow : difference === -1 ? dict.yesterday : null
        const text = relative || date(value)
        return text.charAt(0).toUpperCase() + text.slice(1)
    }

    return {
        language,
        dict,
        t: (key, vars) => fill(dict[key] as string, vars),
        plural: (forms, count) => fill(forms[count === 1 ? 0 : 1], {count}),
        date,
        relativeDate,
        dateTime: (timestamp) => new Intl.DateTimeFormat(locale, {weekday: 'short', day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit'}).format(new Date(timestamp)),
        time: (value) => new Intl.DateTimeFormat(locale, {hour: '2-digit', minute: '2-digit'}).format(value)
    }
}

// First browser language the reseller offers, otherwise the reseller's default
export function preferredLanguage(available: TrackTraceLanguage[], fallback: TrackTraceLanguage): TrackTraceLanguage {
    const browserLanguages = typeof navigator !== 'undefined' ? navigator.languages || [navigator.language] : []

    for (const browserLanguage of browserLanguages) {
        const code = (browserLanguage || '').slice(0, 2).toLowerCase() as TrackTraceLanguage
        if (available.includes(code)) {
            return code
        }
    }

    return available.includes(fallback) ? fallback : available[0] || 'nl'
}

export function isLanguage(value: unknown): value is TrackTraceLanguage {
    return trackTraceLanguages.includes(value as TrackTraceLanguage)
}

export const languageNames: Record<TrackTraceLanguage, string> = {nl: nl.languageName, en: en.languageName, de: de.languageName, fr: fr.languageName}

export const defaultMessages = (language: TrackTraceLanguage) => (dictionaries[language] || nl).messages
